import csp from './csp'
import links from './links'
import vendors from './vendors'

export default {
    csp,
    links,
    vendors
}